import { ReactElement } from "react";
import { DateTime } from "@twiliointernal/e2-commons-shared-utils";

import { Avatar } from "@twilio-paste/core/avatar";
import {
  ChatBubble,
  ChatMessage as PasteChatMessage,
  ChatMessageMeta,
  ChatMessageMetaItem,
} from "@twilio-paste/core/chat-log";
import MediaMessage from "../mediaMessage";

import { copy, ChatMessageProps, MESSAGE_TIME_FORMAT } from "../../definitions";
import { MessageMarkdown } from "@twiliointernal/e2-commons-shared-ui";

const ChatMessage = ({
  message,
  messageDirection,
  participantFriendlyNames = {},
}: ChatMessageProps): ReactElement => {
  const { attachedMedia, author, body, dateCreated } = message;
  const hasAttachedMedia = attachedMedia && attachedMedia.length > 0;
  const agentKey = author || "";
  const agentFriendlyName = participantFriendlyNames[agentKey] || "Agent";
  const timeCreated =
    (dateCreated && new DateTime(dateCreated).format(MESSAGE_TIME_FORMAT)) ??
    "";

  const renderMessageMetaItem = () => {
    if (messageDirection === "outbound") {
      return <ChatMessageMetaItem>{timeCreated}</ChatMessageMetaItem>;
    }

    return (
      <ChatMessageMetaItem>
        <Avatar name={agentFriendlyName} size="sizeIcon20" />
        {`${agentFriendlyName} ・ ${timeCreated}`}
      </ChatMessageMetaItem>
    );
  };

  return (
    <PasteChatMessage variant={messageDirection}>
      <ChatBubble>
        {body && <MessageMarkdown markdown={body} />}
        {hasAttachedMedia && (
          <MediaMessage message={message} messageDirection={messageDirection} />
        )}
      </ChatBubble>
      <ChatMessageMeta
        aria-label={copy.message.ariaLabel(
          messageDirection === "outbound" && message.author
            ? message.author
            : agentFriendlyName || "",
          timeCreated
        )}
      >
        {renderMessageMetaItem()}
      </ChatMessageMeta>
    </PasteChatMessage>
  );
};

export default ChatMessage;
